import React from 'react';
import Typography from '@material-ui/core/Typography';
import type { IRecipient } from '../../common/recipients/types';
import { useShallowSelector } from '../../lib/reduxHooks';
import type { IRootState } from '../../store';
import { RecipientsHeader } from '../common/RecipientsHeader';
import { useStyles } from './Signers/index';

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const carbonCopyRecipientsSelector = (state: IRootState) => ({
  recipients: state.senderBuild.recipientsModal.recipients,
});

interface IState {
  recipients: IRecipient[];
}

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const CarbonCopyRecipients = () => {
  const classes = useStyles();
  const { recipients }: IState = useShallowSelector(carbonCopyRecipientsSelector);
  const carbonCopyRecipients = recipients.filter((r) => r.role === 'CarbonCopy' && r.isActive);
  if (!carbonCopyRecipients.length) return null;
  // eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
  const renderCarbonCopyRecipient = (ccRecipient: IRecipient) => (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
    <div key={ccRecipient.id} className={classes.row} tabIndex={0}>
      <div className={classes.icon} style={{ marginRight: '14px', marginLeft: '2px' }}>
        Cc:
      </div>
      <div className={classes.overflowContainer}>
        <Typography variant="body2">
          {ccRecipient.firstName} {ccRecipient.lastName}
        </Typography>
        <Typography variant="body1" className={`${classes.entry} ${classes.email}`}>
          {ccRecipient.email}
        </Typography>
      </div>
    </div>
  );

  return (
    <div>
      <div className={classes.signingGroup}>
        <RecipientsHeader />
        {carbonCopyRecipients.map((ccRecipient) => renderCarbonCopyRecipient(ccRecipient))}
      </div>
    </div>
  );
};
